'use client'

import { storyblokEditable } from '@storyblok/react'
import { type PropsWithChildren } from 'react'
import { ConditionalWrapper } from 'ui/src/components/ConditionalWrapper'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { type GridColumnsField, type SbBaseBlockProps, type StoryblokAsset } from '@/services/storyblok/storyblok'
import { getImgSrc } from '@/services/storyblok/Storyblok.helpers'
import { DEFAULT_IMAGE_QUALITY } from '@/utils/config'
import { type ImageAspectRatio, ImageWrapper, StyledImage } from './ImageBlock.styles'

export type BaseImageRendererProps = {
  image: StoryblokAsset
  fullBleed?: boolean
  priority?: boolean
  layout?: GridColumnsField
  aspectRatioLandscape?: ImageAspectRatio
  aspectRatioPortrait?: ImageAspectRatio
}
export type ImageBlockRendererProps = PropsWithChildren<SbBaseBlockProps<BaseImageRendererProps>>

export const ImageBlockRenderer = ({ blok, nested, children }: ImageBlockRendererProps) => {
  return (
    <ConditionalWrapper
      condition={!blok.fullBleed && !nested}
      wrapWith={(children) => (
        <GridLayout.Root>
          <GridLayout.Content width={blok.layout?.widths ?? { _: '1' }} align={blok.layout?.alignment ?? 'center'}>
            {children}
          </GridLayout.Content>
        </GridLayout.Root>
      )}
    >
      <ImageWrapper
        {...storyblokEditable(blok)}
        aspectRatioLandscape={blok.aspectRatioLandscape}
        aspectRatioPortrait={blok.aspectRatioPortrait}
      >
        <StyledImage
          src={getImgSrc(blok.image.filename)}
          roundedCorners={!blok.fullBleed}
          alt={blok.image.alt}
          fill
          priority={blok.priority}
          quality={DEFAULT_IMAGE_QUALITY}
        />
        {children}
      </ImageWrapper>
    </ConditionalWrapper>
  )
}
